import { render, staticRenderFns } from "./SortByFilters.vue?vue&type=template&id=f5bcd0c8&scoped=true&"
import script from "./SortByFilters.vue?vue&type=script&lang=js&"
export * from "./SortByFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bcd0c8",
  null
  
)

export default component.exports